(function ($, d, w) {

    let _w = $(w);

    _w.on(w.ZP_READY, onInit);

    function onInit() {
        const elements = $('.zp_slider');
        if (elements.length > 0) {
            elements.each((index, element) => {
                new Slider($(element));
            });
        }
    }

    class Slider {

        constructor(root) {
            this.mySlider = null;
            this.initElements(root);
            this.init();
        }

        init() {

            this.initFlickity();
            if (this.ELEMENTS.root.data('breakpoints').length !== 0) {
                this.initBreakpoints();
            }
        }

        initFlickity() {

            /****************************/
            /*Anfängliches Slide-Element*/
            /****************************/
            let startSlideData = this.ELEMENTS.root.data('start-slide');
            let initialIndex = startSlideData-1;
            if (initialIndex < 0) {
                initialIndex = 0;
            }

            /********/
            /*Bilder*/
            /********/
            let lazyload = false;
            let imagesLoaded = false;
            if (this.ELEMENTS.slideImages.length >= 0) {
                imagesLoaded = true;
                let isLazyloadData = this.ELEMENTS.root.data('is-lazyload');

                if (isLazyloadData === true || isLazyloadData === 'true' || isLazyloadData === 1 || isLazyloadData === '1') {
                    lazyload = true;
                    // this.ELEMENTS.slideImages.addClass('lazyload-on');
                }
                else {
                    lazyload = false;
                }

            }

            /********************/
            /*Unendliches Sliden*/
            /********************/
            let wrapAround = false;
            let infiniteSlideData = this.ELEMENTS.root.data('infinite-slide');
            if (infiniteSlideData === true || infiniteSlideData === 'true' || infiniteSlideData === 1 || infiniteSlideData === '1') {
                wrapAround = true;
            }


            /*************************/
            /*Benutzerdefinierte Höhe*/
            /*************************/
            //TODO: Wenn Viewport zu klein: Bilder verzerren
            let setGallerySize = true;
            let customHeightData = this.ELEMENTS.root.data('custom-height');
            if (typeof customHeightData !== 'undefined') {
                this.ELEMENTS.root.css('max-height', customHeightData+'px');
                this.ELEMENTS.root.css('height', customHeightData+'px');
                // this.ELEMENTS.slideImages.css('height', customHeightData+'px');
                // setGallerySize = false;
            }

            /*****************/
            /*Anpassbare Höhe*/
            /*****************/
            let adaptiveHeight = false;
            let adaptiveHeightOnData = this.ELEMENTS.root.data('adaptive-height-on');
            if (adaptiveHeightOnData === true || adaptiveHeightOnData === 'true' || adaptiveHeightOnData === 1 || adaptiveHeightOnData === '1') {
                adaptiveHeight = true;
            }

            /*************/
            /*Gruppierung*/
            /*************/
            let groupCells = false;
            let groupCellsOnData = this.ELEMENTS.root.data('group-cells-on');
            if (groupCellsOnData === true || groupCellsOnData === 'true' || groupCellsOnData === 1 || groupCellsOnData === '1') {
                groupCells = true;
            }

            /***********/
            /*Ausfüllen*/
            /***********/
            let contain = false;
            let containData = this.ELEMENTS.root.data('contain');
            if (containData === true || containData === 'true' || containData === 1 || containData === '1') {
                contain = true;
            }

            /********/
            /*Breite*/
            /********/
            let slideElementWidthData = this.ELEMENTS.root.data('slide-element-width');
            let slideElementWidthFormatData = this.ELEMENTS.root.data('slide-element-width-format');
            if (typeof slideElementWidthData !== 'undefined') {
                this.ELEMENTS.sliderElements.css('width', slideElementWidthData+slideElementWidthFormatData);
            }

            /********/
            /*Pfeile*/
            /********/
            let arrowsOnData = this.ELEMENTS.root.data('arrows-on');
            // let prevNextButtons = (arrowsOnData === true || arrowsOnData === 'true' || arrowsOnData === 1 || arrowsOnData === '1');
            let prevNextButtons = true;

            /********/
            /*Punkte*/
            /********/
            let dotsOnData = this.ELEMENTS.root.data('dots-on');
            // let pageDots = (dotsOnData === true || dotsOnData === 'true' || dotsOnData === 1 || dotsOnData === '1');
            let pageDots = true;

            /*********/
            /*Autoplay*/
            /*********/
            let autoPlayData = this.ELEMENTS.root.data('autoplay');
            let autoPlay = (autoPlayData >= 0);

            /*****************/
            /*Freies Scrollen*/
            /*****************/
            let freeScrollData = this.ELEMENTS.root.data('free-scroll');
            let freeScroll = (freeScrollData === true || freeScrollData === 'true' || freeScrollData === 1 || freeScrollData === '1');

            /*******************/
            /*Synchronisi̱e̱rung*/
            /*******************/
            let syncData = this.ELEMENTS.root.data('sync');

            let sync = null;
            if (typeof syncData !== 'undefined') {
                this.ELEMENTS.root.addClass(syncData);
                sync = '.'+syncData;
            }

            /**************************/
            /*Flickity-Initialisierung*/
            /**************************/
            this.mySlider = this.ELEMENTS.root.flickity({
                cellSelector: '.zp_slider_element',
                lazyLoad: lazyload,
                imagesLoaded: imagesLoaded,
                prevNextButtons: prevNextButtons,
                setGallerySize: setGallerySize,
                adaptiveHeight: adaptiveHeight,
                pageDots: pageDots,
                groupCells: groupCells,
                contain: contain,
                autoPlay: autoPlay,
                wrapAround: wrapAround,
                freeScroll: freeScroll,
                initialIndex: initialIndex,
                sync: sync
            });

            this.flickityData = this.mySlider.data('flickity');
            // console.log(this.flickityData); //TODO: Entfernen

            /********************************************/
            /*Verarbeitung nach Flickity-Initialisierung*/
            /********************************************/
            //Pfeile
            if (prevNextButtons === true) {

                this.ELEMENTS.arrows = $('#' + this.ELEMENTS.root.attr('id') + ' .flickity-prev-next-button');

                //Farbe
                let arrowsColor = this.ELEMENTS.root.data('arrows-color');
                this.ELEMENTS.arrows.css('color', arrowsColor);

                //Hintergrundfarbe
                let arrowsBackgroundColor = this.ELEMENTS.root.data('arrows-background-color');
                if (arrowsBackgroundColor !== 'transparent') {
                    this.ELEMENTS.arrows.css('background', arrowsBackgroundColor);
                }

                //Farben von ausgewählten Slide-Elementen
                let changeSlideElementArrowColor = () => {

                    let selectedSlideElement = $(this.ELEMENTS.sliderElements[this.flickityData.selectedIndex]);
                    let slideElementArrowColorOn = selectedSlideElement.data('arrows-color-on');

                    if (slideElementArrowColorOn === true || slideElementArrowColorOn === 'true' || slideElementArrowColorOn === 1 || slideElementArrowColorOn === '1') {
                        let slideElementArrowColor = selectedSlideElement.data('arrows-color');
                        this.ELEMENTS.arrows.css('color', slideElementArrowColor);
                    }
                    else {
                        this.ELEMENTS.arrows.css('color', arrowsColor);
                    }

                };
                changeSlideElementArrowColor();
                this.onEvent(changeSlideElementArrowColor, 'select.flickity');

            }

            //Punkte
            if (pageDots === true) {

                this.ELEMENTS.dots = $('#' + this.ELEMENTS.root.attr('id') + ' .flickity-page-dots .dot');
                let dotsBackgroundColor = this.ELEMENTS.root.data('dots-background-color');
                let dotsColor = this.ELEMENTS.root.data('dots-color');

                let changedSlideElementsDotsColor = () => {

                    //Allgemeine Farben
                    this.ELEMENTS.dots = $('#' + this.ELEMENTS.root.attr('id') + ' .flickity-page-dots .dot');

                    //Farbe
                    this.ELEMENTS.dots.css('background', dotsColor);

                    //Hintergrundfarbe
                    if (dotsBackgroundColor !== 'transparent') {
                        this.ELEMENTS.dots.css('border', '5px solid '+dotsBackgroundColor);
                    }

                    //Farben von ausgewählten Slide-Elementen
                    let selectedSlideElement = $(this.ELEMENTS.sliderElements[this.flickityData.selectedIndex]);
                    let slideElementDotsColorOn = selectedSlideElement.data('dots-color-on');
                    if (slideElementDotsColorOn === true || slideElementDotsColorOn === 'true' || slideElementDotsColorOn === 1 || slideElementDotsColorOn === '1') {
                        let slideElementDotsColor = selectedSlideElement.data('dots-color');
                        this.ELEMENTS.dots.css('background', slideElementDotsColor);
                    }
                    else {
                        this.ELEMENTS.dots.css('background', dotsColor);
                    }
                };
                changedSlideElementsDotsColor();
                this.onEvent(changedSlideElementsDotsColor, 'select.flickity');

            }

            /**********/
            /*Parallax*/
            /**********/
            let parallaxData = this.ELEMENTS.root.data('parallax-on');
            if (parallaxData === true || parallaxData === 'true' || parallaxData === 1 || parallaxData === '1') {

                let slideElementsContent = this.ELEMENTS.sliderElements.children();

                //TODO: Bei zwei Slide-Elementen
                // //unendlicher Slide und 2 Slide-Elemente
                // let slideElementsSecendContent = null;
                // if (wrapAround && this.flickityData.slides.length === 2) {
                //     let flickitySlider = this.ELEMENTS.root.find('.flickity-slider');
                //     this.flickityData.cells.forEach( ( slide, i ) => {
                //
                //         $(slide.element).append($(slide.element)[0].children[0].outerHTML);
                //         let slideElementSecendContent = $('#' + $(slide.element).attr('id') + ' > *:last-child');
                //         slideElementSecendContent.addClass('flickity-secend-slide-content');
                //         slideElementSecendContent.css({
                //             position: 'absolute',
                //             top: '0',
                //             zIndex: '-1',
                //             width: '100%',
                //             height: '100%'
                //         });
                //
                //     });
                //     slideElementsSecendContent = this.ELEMENTS.sliderElements.find(' > *:last-child');
                // }


                // get transform property
                let docStyle = document.documentElement.style;
                let transformProp = typeof docStyle.transform == 'string' ? 'transform' : 'WebkitTransform';

                let parallaxSlide = () => {

                    if (!wrapAround) {
                        this.flickityData.cells.forEach( ( slide, i ) => {

                            let slideElementContent = slideElementsContent[i];
                            let x = ( slide.target + this.flickityData.x ) * -1/3;
                            slideElementContent.style[ transformProp ] = 'translateX(' + x  + 'px)';

                        });
                    }
                    //bei unendlichen Sliden
                    else {

                        //TODO: Bei zwei Elementen
                        // //bei 2 Slide-Elementen
                        // if (this.flickityData.slides.length === 2) {
                        //     this.flickityData.cells.forEach( ( slide, i ) => {
                        //         let slideElementContent = slideElementsContent[i];
                        //         let slideElementSecendContent = slideElementsSecendContent[i];
                        //         let xFirstContent   = 0;
                        //         let xSecendContent   = 0;
                        //         if( 0 === i ) {
                        //             xFirstContent = Math.abs( this.flickityData.x ) > this.flickityData.slidesWidth ? ( this.flickityData.slidesWidth +this.flickityData.x + this.flickityData.slides[this.flickityData.slides.length - 1 ].outerWidth + slide.target ) : ( slide.target + this.flickityData.x );
                        //             xSecendContent = ( slide.target + this.flickityData.x );
                        //         }
                        //         else if( i === this.flickityData.slides.length - 1 ) {
                        //             xFirstContent = Math.abs( this.flickityData.x ) + this.flickityData.slides[i].outerWidth < this.flickityData.slidesWidth ? ( slide.target - this.flickityData.slidesWidth + this.flickityData.x - this.flickityData.slides[i].outerWidth ) : ( slide.target + this.flickityData.x );
                        //
                        //             if (this.flickityData.selectedIndex === 1) {
                        //                 xSecendContent = ( slide.target - this.flickityData.slidesWidth + this.flickityData.x - this.flickityData.slides[i].outerWidth );
                        //             }
                        //             else {
                        //                 xSecendContent = ( slide.target - this.flickityData.slidesWidth + this.flickityData.x - this.flickityData.slides[i].outerWidth );
                        //             }
                        //         } else {
                        //             xFirstContent = slide.target + this.flickityData.x;
                        //         }
                        //
                        //         slideElementContent.style[ transformProp ] = 'translateX(' + xFirstContent * ( -1 / 3 ) + 'px)';
                        //         slideElementSecendContent.style[ transformProp ] = 'translateX(' + xSecendContent * ( -1 / 3 ) + 'px)';
                        //
                        //     });
                        // }
                        // //bei mehr als 2 Slide-Elementen
                        // else {
                            this.flickityData.cells.forEach( ( slide, i ) => {

                                let slideElementContent = slideElementsContent[i];
                                let x   = 0;
                                if (this.flickityData.cells.length === 1) {
                                    slideElementContent.style[ transformProp ] = 'translateX(0)';
                                }
                                else {
                                    if( 0 === i ) {
                                        x = Math.abs( this.flickityData.x ) > this.flickityData.slidesWidth ? ( this.flickityData.slidesWidth +this.flickityData.x + this.flickityData.slides[this.flickityData.slides.length - 1 ].outerWidth + slide.target ) : ( slide.target + this.flickityData.x );
                                    } else if( i === this.flickityData.slides.length - 1 ) {
                                        x = Math.abs( this.flickityData.x ) + this.flickityData.slides[i].outerWidth < this.flickityData.slidesWidth ? ( slide.target - this.flickityData.slidesWidth + this.flickityData.x - this.flickityData.slides[i].outerWidth ) : ( slide.target + this.flickityData.x );
                                    } else {
                                        x = slide.target + this.flickityData.x;
                                    }
                                    slideElementContent.style[ transformProp ] = 'translateX(' + x * ( -1 / 3 ) + 'px)';
                                }

                            });
                        //TODO: Bei zwei Slide-Elementen
                        // }


                    }

                };

                this.onEvent(parallaxSlide, 'scroll.flickity');
                //TODO: Bei zwei Elementen
                // //unendlicher Slide und 2 Slide-Elemente
                // if (wrapAround && this.flickityData.slides.length === 2) {
                //     this.onEvent(() => {slideElementsSecendContent.css('z-index', '-1');}, 'settle.flickity');
                // }

            }

            //Wenn alle Slide-Elemente zu sehen sind, wird das Sliden deaktiviert und die Punkte und Pfeile werden ausgeblendet
            let disableArrowsDotsAndDraggable = () => {

                if ($('#' + this.ELEMENTS.root.attr('id') + ' .zp_slider_element.is-selected').length === this.ELEMENTS.sliderElements.length) {
                    this.ELEMENTS.root.addClass('all-slide-elements-visible');
                    this.flickityData.unbindDrag();
                }
                else {
                    this.ELEMENTS.root.removeClass('all-slide-elements-visible');
                    this.flickityData.bindDrag();
                }

            };
            disableArrowsDotsAndDraggable();
            this.onEvent(disableArrowsDotsAndDraggable, 'select.flickity');

            //Lazyload
            //Fügt allen "is-selected"-Elementen "srcset" hinzu
            //TODO: Lazyload in Verbindung mit Flickity-Lazyload
            // if (lazyload === true) {
            //
            //     this.slideImageSrcDatas = [];
            //     this.ELEMENTS.slideImages.each((index, slideImage) => {
            //
            //         let _slideImage = $(slideImage);
            //         let _slideImageSrc = $('#'+_slideImage.attr('id') + ' > img');
            //
            //         //Lazyload für einzelnes Bild aktiviert
            //         if (_slideImageSrc[0].hasAttribute("data-srcset")) {
            //             let slideImageSrcData = _slideImageSrc.attr('data-srcset');
            //             this.slideImageSrcDatas.push(slideImageSrcData);
            //         }
            //
            //         _slideImageSrc.attr('data-flickity-lazyload', 'http://localhost/projekte/Arbeit/Suesges/deployment/wp-content/uploads/2018/02/hearthstone-screenshot-02-01-18-22-17-38.png');
            //     });
            //
            // }
            //
            // let testiko = () => {
            //     // console.log(this.flickityData.selectedIndex);
            //     let _selectedElement = $(this.flickityData.selectedElement);
            //     let _selectedElementImgs = $('#'+_selectedElement.attr('id')+ ' .zp_element.zp_image img')
            //
            //     _selectedElementImgs.each((index, slideImage) => {
            //         console.log(slideImage);
            //         let _slideImage = $(slideImage);
            //         _slideImage.attr('srcset', _slideImage.attr('data-srcset'));
            //     });
            //
            //     // let dataSrc = $('#'+this.flickityData.slides[this.flickityData.selectedIndex].attr('id')+ ' > img').attr('srcset', );
            // };
            //
            // this.onEvent(testiko, 'select.flickity');


            this.textBoxAnimation();

            //Bei Flickity-Inhalten wird manchmal eine falsche Höhe berechnet
            if (this.ELEMENTS.slideImages.length === 0) {
                this.onEvent(()=> {this.flickityData.resize();}, 'load');
            }

        }

        textBoxAnimation () {

            let visibleTextboxes = () => {

                let nextSlideElement = $(this.flickityData.selectedSlide.cells[0].element);
                let nextSlideElementTextbox = nextSlideElement.find('.zp_textbox');

                // console.log(nextSlideElement);

                this.ELEMENTS.textBoxes.removeClass('visible');
                nextSlideElementTextbox.addClass('visible');

            };
            visibleTextboxes();
            this.onEvent(visibleTextboxes, 'select.flickity');

        }

        onEvent(func, event) {

            //Seite geladen
            if (event === 'load') {
                _w.on(ZP_LOAD, () => {
                    func();
                });
            }

            //beim Ändern der Viewportgröße
            else if (event === 'resize') {
                _w.on('resize', () => {
                    func();
                });
            }

            //beim Ändern der Viewportgröße innerhalb von Flickity
            else if (event === 'resize.flickity') {
                _w.on('resize.flickity', () => {
                    func();
                });
            }

            //sofort beim Sliden
            else if (event === 'select.flickity') {
                this.mySlider.on('select.flickity', () => {
                    func();
                });
            }

            //während des Slidens
            else if (event === 'scroll.flickity') {
                this.mySlider.on('scroll.flickity', () => {
                    func();
                });
            }

            //nach dem Sliden
            else if (event === 'settle.flickity') {
                this.mySlider.on('settle.flickity', () => {
                    func();
                });
            }

            //beim Laden eines Bildes mit Flickity-Lazyload
            else if (event === 'lazyload') {
                this.mySlider.on( 'lazyLoad.flickity', () => {
                    func();
                });
            }

        }

        initElements(root) {

            this.ELEMENTS = {};
            this.ELEMENTS.root = root;
            this.ELEMENTS.sliderElements = $('#' + this.ELEMENTS.root.attr('id') + ' .zp_slider_element');
            this.ELEMENTS.arrows = null; //wird erzeugt nachdem Flickity initialisiert wurde
            this.ELEMENTS.dots = null; //wird erzeugt nachdem Flickity initialisiert wurde
            this.ELEMENTS.slideImages = $('#' + this.ELEMENTS.root.attr('id') + ' .zp_slider_element .zp_element.zp_image');
            this.ELEMENTS.slideTexts = $('#' + this.ELEMENTS.root.attr('id') + ' .zp_slider_element .zp_text');
            this.ELEMENTS.textBoxes = $('#' + this.ELEMENTS.root.attr('id') + ' .zp_textbox');

        }

        initBreakpoints ()  {

            let breakpointsData = this.ELEMENTS.root.data('breakpoints');
            let responsiveFirstAddedClassesData = (this.ELEMENTS.root.data('responsive-first-added-classes') != null ? this.ELEMENTS.root.data('responsive-first-added-classes') : '');
            let responsiveFirstRemovedClassesData = (this.ELEMENTS.root.data('responsive-first-removed-classes') != null ? this.ELEMENTS.root.data('responsive-first-removed-classes') : '');


            //Breakpoints definieren
            let breakpoints = [];
            for (let i = 0 ; i < breakpointsData.length ; i++) {

                let breakpointExist = false;
                for (let j = 0; j < breakpoints.length ; j++) {

                    if (breakpointsData[i][0] == breakpoints[j])
                        breakpointExist = true;

                }
                if (!breakpointExist)
                    breakpoints.push([breakpointsData[i][0]]);

            }
            breakpoints.sort((a,b) =>{return b - a});

            //füge zu entfernende oder einzufügende Klassen den Breakpoints hinzu
            for (let i = 0 ; i < breakpoints.length ; i++) {

                let addBreakpointClasses = '';
                let removeBreakpointClasses = '';
                let addBreakpointClassesFirst = '';
                let removeBreakpointClassesFirst = '';
                for (let j = 0; j < breakpointsData.length ; j++) {

                    if (breakpointsData[j][0] == breakpoints[i]) {
                        if (breakpointsData[j][2] === 1) {
                            addBreakpointClasses += breakpointsData[j][1]+' ';
                        }
                        else {
                            removeBreakpointClasses += breakpointsData[j][1]+' ';
                        }
                        if (breakpointsData[j][3] != null) {
                            addBreakpointClassesFirst += breakpointsData[j][3]+' ';
                        }
                        if (breakpointsData[j][4] != null) {
                            removeBreakpointClassesFirst += breakpointsData[j][4]+' ';
                        }
                    }

                }
                breakpoints[i].push(addBreakpointClasses);
                breakpoints[i].push(removeBreakpointClasses);
                breakpoints[i].push(addBreakpointClassesFirst);
                breakpoints[i].push(removeBreakpointClassesFirst);

            }

            let changedClassesOnBreakpoints = () => {

                let windowWidth = _w.width();

                this.ELEMENTS.root.removeClass(responsiveFirstRemovedClassesData);
                this.ELEMENTS.root.addClass(responsiveFirstAddedClassesData);

                for (let i = 0 ; i < breakpoints.length ; i++) {

                    if (windowWidth < breakpoints[i][0]) {

                        this.ELEMENTS.root.removeClass(breakpoints[i][4] );
                        this.ELEMENTS.root.addClass(breakpoints[i][3] );
                        this.ELEMENTS.root.removeClass(breakpoints[i][2]);
                        this.ELEMENTS.root.addClass(breakpoints[i][1]);

                    }

                }

            };

            changedClassesOnBreakpoints();
            this.onEvent(changedClassesOnBreakpoints, 'resize');

        }

    }

})(jQuery, document, window);